import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate'
import nl from 'vee-validate/dist/locale/nl'
import { nlDic } from './translations/vee-validate/nl'
import { enDic } from './translations/vee-validate/en'

Validator.localize({ nl: nl })

const configVee = {
    fieldsBagName: 'fieldsVee',
    locale: 'en',
    dictionary: {
        en: enDic,
        nl: nlDic
    }
}

Vue.use(VeeValidate, configVee)
